'use client';

import { type FC, useEffect } from 'react';
import { useLoggedIn } from '@/tracking/use-logged-in';
import { useDataDog } from './use-data-dog-rum';
import { useTrackVirtPathAndPageMeta } from './use-track-virt-path-and-page-meta';

type TrackingProps = {
  dataDogViewName: string;

  state: any; // todo
  virtPathViewName: string;
};

export const Tracking: FC<TrackingProps> = ({ dataDogViewName, state, virtPathViewName }) => {
  const trackVirtPathAndPageMeta = useTrackVirtPathAndPageMeta();

  const loggedIn = useLoggedIn();

  useDataDog({
    checkout: 'Heating',
    state,
    viewName: dataDogViewName,
  });

  useEffect(() => {
    trackVirtPathAndPageMeta(
      `${loggedIn ? '/serviceview' : ''}/checkout-b2c-wärmestrom-${virtPathViewName.replace(' ', '-').toLocaleLowerCase()}/`,
      `${loggedIn ? 'Serviceview ' : ''}Checkout B2C WärmeStrom ${virtPathViewName}`,
      'Other',
    );
  }, [loggedIn, trackVirtPathAndPageMeta, virtPathViewName]);

  return null;
};
